document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-mobile-filter-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const realFilterButton = document.querySelector('.t4s-btn-filter');

    if (!realFilterButton) {
      console.warn('[SC Collection] Real Kalles filter button not found.');
      return;
    }

    realFilterButton.click();
  });
});